import React from 'react';
import { Layout, Menu as BaseMenu } from 'antd';
import { subscribe } from 'alfa';
import { withTranslation } from 'react-i18next';

import Link from '../link';
import BusinessList from './BusinessList';
import UserMenu from './UserMenu';
import './menu.scss';

const Menu = withTranslation()((props) => (
  <Layout.Header className="menu-block">
    <div className="block-inner">
      <Link to="/">
        <div className="logo" />
      </Link>
      <BaseMenu mode="horizontal" theme="dark" style={{ lineHeight: '64px', margin: '0' }} selectable={false}>
        {BusinessList(props)}
        {UserMenu(props)}
      </BaseMenu>
    </div>
  </Layout.Header>
));

export default subscribe(Menu, ['set', 'keyAdderVisible', 'business', 'businesses', 'user'], ['keyAdderVisible']);
